angular
  .module("autorizzazioneSdd.components", [])
  .component("autorizzazioneSdd", {
    templateUrl: "ng/components/autorizzazioneSdd/autorizzazioneSdd.html",
    bindings: {
      id: "<",
      raccoltaInfo: "=",
      ibanIsOk: "&",
      ibanIsNotOk: "&",
      model: "=",
      autorizzazione: "&",
      digital: "=",
      isM14: "=",
      isArc: "=",
      isPostVendita: "=",
      richiestePostVendita: "=",
      isContratto: "<",
      showOtherBank: "=",
    },
    controllerAs: "autorizzazioneSddCtrl",
    controller: function autorizzazioneSddController(
      HttpService,
      FactoryObj,
      $typeDomainService,
      $financialApiService,
      $portalService,
      $rootScope
    ) {
      var self = this;
      //self.giuridicVersion = $giuridicVersion;

      self.$onInit = function () {
        self.raccoltaInfo = self.raccoltaInfo || null;
        self.placeholder = "";
        self.raccoltaInfo = {
          autorizzazioneSDD: {
            iban: "",
            banca: {
              name: "",
            },
            ibanRadio: "",
            showOtherBank: false,
            otherBanks: "",
          },
        };

        self.loading = {
          listaIban: false,
        };
        self.dropdown = {
          listaIban: [],
          listaIbanObj: [],
          listaBanche: [],
        };

        self.isM12 = false;
        self.warnings = {};

        if (self.id === "varCoordBan" || !self.isPostVendita) {
          self.getIbanDropdown();
        }

        self.listBank();

        if (!self.isArc) {
          if (self.model.financialCustomer.metadata.autorizzazione) {
            self.raccoltaInfo.autorizzazioneSDD =
              self.model.financialCustomer.metadata.autorizzazione;
          }
        }

        if (self.isPostVendita) {
          if (self.richiestePostVendita) {
            self.raccoltaInfo.autorizzazioneSDD.iban =
              self.richiestePostVendita.iban;
            self.raccoltaInfo.autorizzazioneSDD.showOtherBank =
              self.richiestePostVendita.showOtherBank;
            self.raccoltaInfo.autorizzazioneSDD.otherBanks =
              self.richiestePostVendita.otherBanks;
          }
        }

        if (
          !self.isPostVendita &&
          getWizardMap(self.model.viewIndex) == "M12"
        ) {
          self.isM12 = true;
          self.ibanIsOk();
        }

        self.placeholder = self.isPostVendita
          ? "LBL_NEW_BANK_COORD_PLACEHOLDER"
          : "LBL_SELECT_IBAN_PLACEHOLDER";

        self.plcShowOtherBank = self.isPostVendita && self.isArc
        ? "PLC_OTHER_BANK_CESS"
        : "PLC_OTHER_BANK";
      };

      self.$onChanges = function (changes) {
        console.log("changes :", changes);
        if (changes.isContratto.currentValue) {
          self.getIbanDropdown();
        }
      };

      self.getIbanDropdown = function () {
        self.loading.listaIban = true;

        if (self.digital) {
          var riUserGInput = self.digital
            ? self.model.financialCustomer.metadata.riUserG
            : self.richiestePostVendita.metadata.variazioneAnagrafica;

          $typeDomainService
            .getListIban(riUserGInput, true)
            .then(function (listAppNsilIban) {
              if (listAppNsilIban && listAppNsilIban.length > 0) {
                self.dropdown.listaIbanObj = listAppNsilIban;
                self.dropdown.listaIban = [];
                listAppNsilIban.forEach(function (el) {
                  self.dropdown.listaIban.push(el.iban);
                });
              }
            })
            .catch(function (err) {
              console.log(err);
              self.dropdown.listaIban = [];
            })
            .finally(function () {
              console.log("getIbanDropdown finally");
              if (
                self.dropdown.listaIban &&
                self.dropdown.listaIban.length > 0
              ) {
                self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
              } else {
                self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
              }
              self.loading.listaIban = false;
            });
        } else {
          if (self.isPostVendita) {
            $typeDomainService
              .getListIbanPostVendita()
              .then(function (listAppNsilIban) {
                if (listAppNsilIban && listAppNsilIban.length > 0) {
                  self.dropdown.listaIbanObj = listAppNsilIban;
                  self.dropdown.listaIban = [];
                  listAppNsilIban.forEach(function (el) {
                    self.dropdown.listaIban.push(el.iban);
                  });
                }
              })
              .catch(function (err) {
                console.log(err);
                self.dropdown.listaIban = [];
              })
              .finally(function () {
                console.log("getIbanDropdown finally");
                if (
                  self.dropdown.listaIban &&
                  self.dropdown.listaIban.length > 0
                ) {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
                } else {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
                }
                self.loading.listaIban = false;
              });
          } else {
            $typeDomainService
              .getListIban(
                FactoryObj.selectedUserG && FactoryObj.selectedUserG.ndg
              )
              .then(function (listAppNsilIban) {
                if (listAppNsilIban && listAppNsilIban.length > 0) {
                  self.dropdown.listaIbanObj = listAppNsilIban;
                  self.dropdown.listaIban = [];
                  listAppNsilIban.forEach(function (el) {
                    self.dropdown.listaIban.push(el.iban);
                  });
                }
              })
              .catch(function (err) {
                console.log(err);
                self.dropdown.listaIban = [];
              })
              .finally(function () {
                console.log("getIbanDropdown finally");
                if (
                  self.dropdown.listaIban &&
                  self.dropdown.listaIban.length > 0
                ) {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = true;
                } else {
                  self.raccoltaInfo.autorizzazioneSDD.bySelect = false;
                }
                self.loading.listaIban = false;
              });
          }
        }
      };

      self.getListaIban = function (search, ibanList) {
        if (ibanList.length) {
          var newIbanList = ibanList.slice();
          if (search && newIbanList.indexOf(search) === -1) {
            newIbanList.unshift(search);
          }
          return newIbanList;
        }
      };

      self.listBank = function () {
        $typeDomainService
          .getDomainSet("RI_DROPDOWN_DOMAINS", "BANKS")
          .then(function (response) {
            self.dropdown.listaBanche = response.domainList;
            self.selectBank();
          });
      };

      self.selectBank = function () {
        self.warnings.iban = false;
        if (self.raccoltaInfo.autorizzazioneSDD.iban) {
          self.raccoltaInfo.autorizzazioneSDD.iban =
            self.raccoltaInfo.autorizzazioneSDD.iban
              .toUpperCase()
              .trim()
              .slice(0, 27);
          if (!self.raccoltaInfo.autorizzazioneSDD.ibanRadio) {
            self.raccoltaInfo.autorizzazioneSDD.ibanRadio = "b2b";
          }
          var iban = self.raccoltaInfo.autorizzazioneSDD.iban;
          if (checkiban(iban)) {
            self.warnings.iban = false;
            var code = iban.slice(5, 10);
            var bank = self.dropdown.listaBanche.find(function (el) {
              return el.value == code;
            });
          } else {
            self.warnings.iban = true;
            self.raccoltaInfo.autorizzazioneSDD.banca = null;
            self.ibanIsNotOk();
            return;
          }
          if (bank) {
            self.raccoltaInfo.autorizzazioneSDD.banca = bank;
            $("#select-banca-container .select2").select2();
            self.warnings.newBank = false;

            if (!self.isPostVendita) {
              self.model.financialCustomer.metadata.autorizzazione =
                self.raccoltaInfo.autorizzazioneSDD;
              self.autorizzazione &&
                self.autorizzazione({
                  aut: self.model.financialCustomer.metadata.autorizzazione,
                });
            } else {
              // self.richiestePostVendita = {};
              self.richiestePostVendita = self.raccoltaInfo.autorizzazioneSDD;
              self.autorizzazione({
                aut: self.richiestePostVendita,
              });
            }

            self.ibanIsOk();
          } else {
            self.newBank = {
              tableName: "RI_DROPDOWN_DOMAINS",
              columnName: "BANKS",
              // name will be added when calling self.insertBank();
              name: "",
              value: code,
            };

            self.raccoltaInfo.autorizzazioneSDD.banca.name = ''
            self.warnings.newBank = true;

            if (!self.isPostVendita) {
              self.model.financialCustomer.metadata.autorizzazione =
                self.raccoltaInfo.autorizzazioneSDD;
            } else {
              self.richiestePostVendita = self.raccoltaInfo.autorizzazioneSDD;
            }

            // self.ibanIsOk();
            if (!self.isArc) {
              self.insertBank();
            }            
          }

          if (self.digital && checkiban(iban)) {
            callcheckIban(self.raccoltaInfo.autorizzazioneSDD.iban);
          }
        } else {
          self.raccoltaInfo.autorizzazioneSDD.banca = {};
          self.warnings.newBank = false;
          if (self.isPostVendita) {
            self.autorizzazione({
              aut: self.richiestePostVendita,
            });
            self.ibanIsNotOk();
          }
        }
        if (self.warnings && self.warnings.newBank) {
          if (
            self.raccoltaInfo.autorizzazioneSDD.banca &&
            !self.raccoltaInfo.autorizzazioneSDD.banca.name
          ) {
            self.ibanIsNotOk();
          } else if (
            self.raccoltaInfo.autorizzazioneSDD.banca &&
            self.raccoltaInfo.autorizzazioneSDD.banca.name
          ) {
            self.ibanIsOk();
          }
        }
      };

      /** This method is called after the FINAL insert Contract **/
      self.insertBank = function () {
        if (self.newBank != null) {
          if (
            !!self.raccoltaInfo.autorizzazioneSDD &&
            !!self.raccoltaInfo.autorizzazioneSDD.banca &&
            !!self.raccoltaInfo.autorizzazioneSDD.banca.name
          ) {
            self.newBank.name = self.raccoltaInfo.autorizzazioneSDD.banca.name;
            console.log("try to add new IBAN bank in the Uni Type Domain... ");
            HttpService.send("/uni/typedomain/insertDomainSet", {
              uniTypeDomain: self.newBank,
            }).then(function (response) { });
          }
        }
      };

      self.handleChange = function (name, value) {
        switch (name) {
          case "bank":
            self.raccoltaInfo.autorizzazioneSDD.banca.name = value;
            callcheckIban(self.raccoltaInfo.autorizzazioneSDD.iban);
            break;
          case "otherBanks":
            self.raccoltaInfo.autorizzazioneSDD[name] = value;
            self.selectBank();
            break;
          default:
            break;
        }

      };

      var callcheckIban = function (iban) {
        self.isCheckingIban = true;
        $financialApiService
          .checkIban(iban)
          .then(function (ibanResponse) {
            if (
              ibanResponse.keyMessage == "LBL_CHECK_IBAN_UNKNOWN" ||
              ibanResponse.keyMessage == "LBL_CHECK_IBAN_ANNULLED" ||
              ibanResponse.keyMessage == "LBL_CHECK_IBAN_ERROR_ARC"
            ) {
              //mantis n. 0015573
              if ($portalService.isAra()) {
                self.ibanIsNotOk();
              } else if ($portalService.isAru()) {
                if (self.raccoltaInfo.autorizzazioneSDD.banca.name) {
                  self.ibanIsOk();
                } else {
                  self.ibanIsNotOk();
                }
              }
            } else {
              self.ibanIsOk();
            }
            self.isCheckingIban = false;
          })
          .catch(function (err) {
            self.isCheckingIban = false;
            console.log("Errore: ", err);
          });
      };

      var getWizardMap = function (viewIndex) {
        return $rootScope.wizardMap.find(function (element) {
          return element.index == viewIndex;
        }).viewName;
      };
    },
  });